import React from 'react';

import { Box, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { SOURCE_FIELD_KEYS } from '../../constants';

import ControlledInfoChip from './ControlledInfoChip';

const SourceInfoFields = ({ control, disabled, validFields }) => {
    const { t } = useTranslation();

    return (
        <Box alignItems="center" display="flex" flexWrap="wrap" gap={2}>
            <Typography variant="body2">{t('Information')}:</Typography>

            {Object.values(SOURCE_FIELD_KEYS).map(
                (key) =>
                    (!validFields || validFields.includes(key)) && (
                        <ControlledInfoChip
                            control={control}
                            disabled={disabled}
                            key={key}
                            name={key}
                        />
                    ),
            )}
        </Box>
    );
};

SourceInfoFields.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    validFields: PropTypes.array,
};

export default SourceInfoFields;
